import _ from 'lodash'

export const loading = state => _.get(state, 'auth.isLoading', false)
export const error = state => _.get(state, 'auth.error', false)
export const errorMessage = state => _.get(state, 'auth.errorMessage', '')
export const token = state => _.get(state, 'auth.token', '')
export const user = state => _.get(state, 'auth.user', '')
